import { createAsyncThunk } from '@reduxjs/toolkit';

import api from 'api';

export const loadMilestones = createAsyncThunk(
    'api/application/{application_id}/milestones',
    async (appId: string) => await api.application.milestones.get(appId)
);

type Props = {
    page?: number;
    pageSize?: number;
    client_status?: string;
    payment_status?: string;
    program_name?: string;
    case_id?: string;
    external_id?: string;
    candidate_name?: string;
    candidate_email?: string;
    sort_status_updated_at?: 'asc' | 'desc';
    backoffice_id?: string;
    consultant_id?: string;
    sales_id?: string;
    service_provider_id?: string;
};

export const loadSalesClients = createAsyncThunk(
    'api/cases',
    async ({
        page,
        pageSize,
        client_status,
        payment_status,
        program_name,
        case_id,
        external_id,
        candidate_name,
        candidate_email,
        sort_status_updated_at,
        backoffice_id,
        consultant_id,
        sales_id,
        service_provider_id,
    }: Props) => {
        return await api.clients.get(
            page,
            pageSize,
            client_status,
            payment_status,
            program_name,
            case_id,
            external_id,
            candidate_name,
            candidate_email,
            sort_status_updated_at,
            backoffice_id,
            consultant_id,
            sales_id,
            service_provider_id
        );
    }
);
